import { authenticated } from '../../helpers/auth-header';
import insighttAPI from '../clients/insightt-api-client';
import { newCompanyEndpoints } from '../endpoints';

const getCompanyData = () => authenticated(insighttAPI).get(newCompanyEndpoints.getExistingBasicInfoAPI());

const getMyCompany = () => authenticated(insighttAPI).get(newCompanyEndpoints.getCompanyAPI());

export const companyService = {
  getCompanyData,
  getMyCompany,
};
